import { render } from "./AHS_DDSD_Logo.vue?vue&type=template&id=36c1aa97"
import script from "./AHS_DDSD_Logo.vue?vue&type=script&lang=js"
export * from "./AHS_DDSD_Logo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__